<script>
import { he } from 'date-fns/locale'

export default {
	name: 'IconSvgTxt',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3719 4.104C12.9072 4.10356 12.4615 3.92241 12.1328 3.60029C11.804 3.27818 11.6191 2.84138 11.6184 2.38572V0H3.78734C3.1807 0 2.5989 0.23626 2.16994 0.656792C1.74097 1.07733 1.5 1.64768 1.5 2.2424V15.7602C1.5 16.3549 1.74097 16.9253 2.16994 17.3458C2.5989 17.7663 3.1807 18.0026 3.78734 18.0026H13.1884C13.795 18.0026 14.3768 17.7663 14.8057 17.3458C15.2347 16.9253 15.4757 16.3549 15.4757 15.7602V4.104H13.3719Z"
				:fill="color" />
			<path
				d="M15.4757 4.104H13.372C12.9072 4.10356 12.4615 3.92241 12.1328 3.60029C11.8041 3.27818 11.6191 2.84138 11.6184 2.38572V0L15.4757 4.104Z"
				fill="#0055A3" />
			<path
				d="M12.6011 6.97717H3.82486C3.74061 6.97695 3.65989 6.94404 3.60032 6.88564C3.54075 6.82724 3.50718 6.7481 3.50696 6.66551C3.50696 6.58278 3.54042 6.50342 3.60001 6.44484C3.6596 6.38626 3.74047 6.35325 3.82486 6.35303H12.6011C12.6855 6.35325 12.7664 6.38626 12.826 6.44484C12.8855 6.50342 12.919 6.58278 12.919 6.66551C12.9188 6.7481 12.8852 6.82724 12.8256 6.88564C12.7661 6.94404 12.6854 6.97695 12.6011 6.97717Z"
				fill="#0055A3" />
			<path
				d="M12.6011 8.8413H3.82486C3.74061 8.84108 3.65989 8.80817 3.60032 8.74977C3.54075 8.69138 3.50718 8.61224 3.50696 8.52965C3.50696 8.44692 3.54042 8.36756 3.60001 8.30898C3.6596 8.2504 3.74047 8.21738 3.82486 8.21716H12.6011C12.6855 8.21738 12.7664 8.2504 12.826 8.30898C12.8855 8.36756 12.919 8.44692 12.919 8.52965C12.9188 8.61224 12.8852 8.69138 12.8256 8.74977C12.7661 8.80817 12.6854 8.84108 12.6011 8.8413Z"
				fill="#0055A3" />
			<path
				d="M12.6011 10.7054H3.82486C3.74047 10.7052 3.6596 10.6722 3.60001 10.6136C3.54042 10.555 3.50696 10.4757 3.50696 10.393C3.50718 10.3104 3.54075 10.2312 3.60032 10.1728C3.65989 10.1144 3.74061 10.0815 3.82486 10.0813H12.6011C12.6854 10.0815 12.7661 10.1144 12.8256 10.1728C12.8852 10.2312 12.9188 10.3104 12.919 10.393C12.919 10.4757 12.8855 10.555 12.826 10.6136C12.7664 10.6722 12.6855 10.7052 12.6011 10.7054Z"
				fill="#0055A3" />
			<path
				d="M12.6011 12.5686H3.82486C3.74054 12.5686 3.65969 12.5358 3.60007 12.4773C3.54045 12.4189 3.50696 12.3396 3.50696 12.2569C3.50696 12.1742 3.54042 12.0949 3.60001 12.0363C3.6596 11.9777 3.74047 11.9447 3.82486 11.9445H12.6011C12.6855 11.9447 12.7664 11.9777 12.826 12.0363C12.8855 12.0949 12.919 12.1742 12.919 12.2569C12.919 12.3396 12.8855 12.4189 12.8259 12.4773C12.7663 12.5358 12.6854 12.5686 12.6011 12.5686Z"
				fill="#0055A3" />
			<path
				d="M17.1349 14.2169H6.50646C5.75254 14.2169 5.14136 14.8161 5.14136 15.5552V18.6617C5.14136 19.4008 5.75254 20 6.50646 20H17.1349C17.8888 20 18.5 19.4008 18.5 18.6617V15.5552C18.5 14.8161 17.8888 14.2169 17.1349 14.2169Z"
				fill="#0055A3" />
			<path d="M8.77262 17.7809V18.3867H8.13257V17.7809H8.77262Z" fill="#F3F3F6" />
			<path d="M10.9308 15.8811V16.3636H10.2364V18.3868H9.61503V16.3636H8.92737V15.8811H10.9308Z"
				  fill="#F3F3F6" />
			<path
				d="M12.7421 18.3868L12.2032 17.6069L11.7399 18.3868H11.0319L11.8487 17.0969L11.0063 15.8811H11.7399L12.2644 16.6361L12.7166 15.8811H13.4212L12.6154 17.1427L13.4756 18.3868H12.7421Z"
				fill="#F3F3F6" />
			<path d="M15.5506 15.8811V16.3636H14.857V18.3868H14.2348V16.3636H13.548V15.8811H15.5506Z" fill="#F3F3F6" />
		</svg>
	</div>
</template>

<style scoped>

</style>